import React from 'react'
import '../../assets/styles/style.scss'


const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader